<template>
  <div>
    <!-- 维护预告条已移至 AppLayout 内（TopNav 下方），避免加载后把导航整体顶下去 -->
    <div
      v-if="shouldBlockByMaintenance"
      class="maint-overlay"
    >
      <div class="maint-card">
        <h1>{{ maintenance?.title || '系统维护中' }}</h1>
        <p class="desc">
          {{ maintenance?.content || '管理员正在上传更新，暂时无法访问。' }}
        </p>
        <p
          v-if="maintenance?.estimatedRecoveryAt"
          class="meta"
        >
          预计恢复：{{ formatDateTime(maintenance.estimatedRecoveryAt) }}
        </p>
        <p
          v-if="maintenance?.contactInfo"
          class="meta"
        >
          联系方式：{{ maintenance.contactInfo }}
        </p>
        <el-button
          type="primary"
          plain
          @click="refreshNow"
        >
          刷新状态
        </el-button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { useMaintenanceStore } from '@/stores/maintenance'

const maintenanceStore = useMaintenanceStore()
const authStore = useAuthStore()
const route = useRoute()

const maintenance = computed(() => maintenanceStore.maintenance)
const isMaintenanceActive = computed(() => maintenanceStore.isMaintenanceActive)
const isSuperAdminAdminRoute = computed(() => authStore.isSuperAdmin() && route.path.startsWith('/admin'))
const shouldBlockByMaintenance = computed(() => isMaintenanceActive.value && !isSuperAdminAdminRoute.value)

const pad = (n) => (n < 10 ? `0${n}` : `${n}`)

const formatDateTime = (value) => {
  if (!value) return ''
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return value
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`
}

const refreshNow = async () => {
  await maintenanceStore.fetchRuntime()
}

onMounted(() => {
  maintenanceStore.start()
})

onBeforeUnmount(() => {
  maintenanceStore.stop()
})
</script>

<style scoped lang="scss">
.maint-overlay {
  position: fixed;
  inset: 0;
  z-index: 5000;
  background: rgba(10, 14, 24, 0.78);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.maint-card {
  width: min(680px, 100%);
  background: #fff;
  border-radius: 16px;
  padding: 28px 24px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.35);
  text-align: center;

  h1 {
    margin: 0;
    font-size: 28px;
    color: #1f2937;
  }

  .desc {
    margin: 14px 0;
    font-size: 16px;
    line-height: 1.7;
    color: #374151;
  }

  .meta {
    margin: 4px 0;
    font-size: 14px;
    color: #6b7280;
  }
}

</style>

